type ListenerDef = {
    callback: (data?: any) => any
    prefix?: string
    suffix: string
};

const listenerMatches = (event, listener: ListenerDef): boolean => {
    const {prefix, suffix} = listener;
    if (prefix) {
        return event.startsWith(prefix) && event.endsWith(suffix);
    } else {
        return event.indexOf(":") === -1 && event.endsWith(suffix);
    }

}

export default class EventEmitter {

    _listeners: ListenerDef[]

    constructor() {
        this._listeners = [];
    }

    on(event, listener) {
        const splitIdx = event.indexOf(":");
        const listenerDef = {
            callback: listener,
            prefix: splitIdx > -1 ? event.substring(0, splitIdx + 1) : undefined,
            suffix: splitIdx > -1 ? event.substring(splitIdx + 1) : event
        };
        this._listeners.push(listenerDef);
        return {
            unsubscribe: () => this._unsubscribe(listenerDef)
        }
    }

    _unsubscribe(listenerDef) {
        const listenerIndex = this._listeners.indexOf(listenerDef);
        if (listenerIndex > -1) {
            this._listeners.splice(listenerIndex, 1);
        }
    }

    emit(event, data?) {
        for (const listener of this._listeners) {
            if (listenerMatches(event, listener)) {
                listener.callback(data);
            }
        }
    }

    removeAllListeners() {
        this._listeners = [];
    }
}